import Environment from '@config/environment';
import { useTranslation } from 'next-i18next';
import styles from './negotiation-listings-error-state.module.scss';

const NegotiationListingsErrorState = () => {
  const { t } = useTranslation('common');

  const reload = () => {
    window.location.reload();
  };

  return (
    <div className={styles.offersErrorState}>
      <img
        loading="lazy"
        width={48}
        height={48}
        src={`${Environment.assetsPath}/images/svg/warning.svg`}
        alt=""
        aria-hidden="true"
      />
      <p className={`vc-heading-A24 ${styles.offersErrorState__title}`}>{t('BUYING_OFFERS.ERROR_STATE.TITLE')}</p>
      <p className={styles.offersErrorState__subtitle}>{t('BUYING_OFFERS.ERROR_STATE.SUBTITLE')}</p>
      <button
        onClick={reload}
        className={'vc-btn vc-btn--rounded-secondary vc-btn--medium'}
      >
        {t('BUYING_OFFERS.ERROR_STATE.CTA_RELOAD')}
      </button>
    </div>
  );
};

export default NegotiationListingsErrorState;
